import { useEffect, useState } from 'react'
import {
    BaseNavItem,
    SubSection,
} from '@/src/common/components/elements/Layout/Navigation/StyledComponents'
import Link from 'next/link'
import { INavItemProps } from '@/src/common/components/elements/Layout/Navigation/Mobile/types'
import NavigationHeader from '@/src/common/components/elements/Layout/Navigation/Mobile/NavigationHeader'
import NavigationSubSection from '@/src/common/components/elements/Layout/Navigation/Mobile/NavigationSubSection'

const NavigationItem = ({
    item,
    menuIsClosing,
    closeMenu,
    style = {},
}: INavItemProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    useEffect(() => {
        if (menuIsClosing) {
            setIsOpen(false)
        }
    }, [menuIsClosing])

    return (
        <BaseNavItem>
            {item?.url ? (
                <Link passHref href={item.url}>
                    <NavigationHeader
                        item={item}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        style={style}
                        closeMenu={closeMenu}
                    />
                </Link>
            ) : (
                <NavigationHeader
                    item={item}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    closeMenu={closeMenu}
                    style={style}
                />
            )}
            {isOpen && (
                <SubSection>
                    {item?.subSection?.map((section) => {
                        return (
                            <NavigationSubSection
                                section={section}
                                key={section.testId}
                                closeMenu={closeMenu}
                            />
                        )
                    })}
                </SubSection>
            )}
        </BaseNavItem>
    )
}

export default NavigationItem
